import { Fountain } from "fountain-js";

import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";
import { TextAreaBinding } from "y-textarea";

import * as utils from "./utils.ts";
import { adjectives } from "./words/adjectives.ts";
import { nouns } from "./words/nouns.ts";

const urlParams = new URLSearchParams(window.location.search);
let fileId = urlParams.get("file");

if (!fileId) {
	fileId = `${utils.random(adjectives)}-${utils.random(nouns)}-${utils.random(nouns)}`;
	window.history.replaceState({}, "", `?file=${fileId}`);
}

const fileIdElement = document.getElementById("file-id");
if (fileIdElement) fileIdElement.textContent = fileId;

const copyBtn = document.getElementById("copy-btn");
if (copyBtn) {
	copyBtn.addEventListener("click", () => {
		navigator.clipboard
			.writeText(window.location.href)
			.then(() => {
				if (fileIdElement) {
					fileIdElement.textContent = "Copied!";
					setTimeout(() => {
						fileIdElement.textContent = fileId!;
					}, 800);
				}
			})
			.catch(err => {
				console.error("Failed to copy URL:", err);
			});
	});
}

const ydoc = new Y.Doc();
const ytext = ydoc.getText("content");

const editor = document.getElementById("editor") as HTMLTextAreaElement;
const preview = document.querySelector("#preview") as HTMLDivElement;

const fountain = new Fountain();

function updatePreview() {
	const fountainContent = editor.value;
	const output = fountain.parse(fountainContent);
	const htmlContent = output.html.script;
	preview.innerHTML = htmlContent;
}

editor.addEventListener("input", updatePreview);
editor.addEventListener("selectionchange", updatePreview);
updatePreview();

const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
const wsUrl = `${wsProtocol}//${window.location.host}/ws`;

const provider = new WebsocketProvider(wsUrl, fileId, ydoc, {
	connect: true,
	WebSocketPolyfill: WebSocket,
});

window.addEventListener("beforeunload", () => provider.destroy());

const statusIndicator = document.getElementById("status-indicator");
const statusText = document.getElementById("status-text");

provider.on("status", (event: { status: string }) => {
	const status = event.status as "connected" | "connecting" | "disconnected";
	if (statusIndicator && statusText) {
		statusIndicator.className = `status-indicator ${status}`;

		console.log("Connection status:", status);

		if (status === "connected") {
			statusText.innerText = "Connected";
		} else if (status === "connecting") {
			statusText.innerText = "Connecting...";
		} else if (status === "disconnected") {
			statusText.innerText = "Disconnected";
		}
	}
});

provider.on("connection-error", (error: any) => {
	console.error("Connection error:", error);
});

provider.on("connection-close", event => {
	if (event) {
		if (event.code === 1008) {
			alert(`Connection closed: ${event.reason}`);
			window.location.href = "/";
			return;
		}
	}
});

new TextAreaBinding(ytext, editor, {
	awareness: provider.awareness,
	clientName: "Editor",
	color: { r: 47, g: 226, b: 147 },
});

// naive scroll-sync implementation, to refine later

let isSyncingScroll = false;

editor.addEventListener("scroll", () => {
	if (isSyncingScroll) return;
	isSyncingScroll = true;

	const editorScrollPercent =
		editor.scrollTop / (editor.scrollHeight - editor.clientHeight);
	const previewMaxScroll = preview.scrollHeight - preview.clientHeight;

	preview.scrollTop = editorScrollPercent * previewMaxScroll;

	setTimeout(() => (isSyncingScroll = false), 10);
});

preview.addEventListener("scroll", () => {
	if (isSyncingScroll) return;
	isSyncingScroll = true;

	const previewScrollPercent =
		preview.scrollTop / (preview.scrollHeight - preview.clientHeight);
	const editorMaxScroll = editor.scrollHeight - editor.clientHeight;

	editor.scrollTop = previewScrollPercent * editorMaxScroll;

	setTimeout(() => (isSyncingScroll = false), 10);
});
